export default {"src":"/uk/_next/static/media/myPensionsIconYellow.6e54880a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};